import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { useWindowSize } from 'react-use'
import { useTranslation } from 'react-i18next'

// components
import { Button } from '@/components/atoms'
import { MiwaPcidInput } from './miwa-pcid-input'

// contexts
import { MiwaAppWebsocketContext } from '@/contexts/miwa-app-websocket'

// models
import { TMiwaAppWebsocketContext } from '@/models/miwa-lock'

// constants
import { HEADER_HEIGHT, MAIN_CONTAINER_WITH_HEADER_BAR_PADDING_VERTICAL, SETTING_MANAGER_LIST_MARGIN } from '@/constants/layout'

export const SettingMiwaLock: React.FC = () => {
  const windows = useWindowSize()
  const { t } = useTranslation()

  const { isLoadingFetchConnectionInfo, connect, isMiwaAppConnected } = useContext<TMiwaAppWebsocketContext>(MiwaAppWebsocketContext)

  return (
    <div
      css={guestRoomHeaderStyle}
      style={{
        height: windows.height - HEADER_HEIGHT - MAIN_CONTAINER_WITH_HEADER_BAR_PADDING_VERTICAL - SETTING_MANAGER_LIST_MARGIN + 32 + 13,
      }}
    >
      {isMiwaAppConnected ? (
        <>
          <p css={paragraphStyle}>{t('Connect websocket success')}</p>
        </>
      ) : (
        <>
          <p css={paragraphStyle}>{t('Please keep window app open')}</p>
          <div css={inputWrapperStyle}>
            <div css={inputStyle}>
              <MiwaPcidInput id="pcId" />
            </div>
            <Button
              width={63}
              height={32}
              buttonType={isLoadingFetchConnectionInfo ? 5 : 1}
              isDisabled={isLoadingFetchConnectionInfo}
              onClick={connect}
            >
              {t('Connect')}
            </Button>
          </div>
        </>
      )}
    </div>
  )
}

const guestRoomHeaderStyle = css({
  padding: '32px 27px',
})

const paragraphStyle = css({
  color: '#676767',
  fontSize: '14px',
  fontWeight: 'bold',
  lineHeight: '27px',
  letterSpacing: '0.7px',
  marginBottom: '32px',
})

const inputStyle = css({
  width: '410px',
  marginRight: '16px',
})

const inputWrapperStyle = css({
  display: 'flex',
  alignItems: 'flex-end',
})
